__webpack_require__.p = "/ca/vim/fr-ca/";